/**
 * The maximum number of tiers allowed in a tiered billing plan,
 * minus the last tier which does not require a tierEnd.
 */
export const MAX_TIERS = 24;

export const MAX_ASSET_BASED_FEE_RATE = 250;

export const MAX_FIXED_FEE_AMOUNT = 1_000_000;
